export const routeCache = {
    methods: {
        // 用于刷新页面时获取路由参数缓存值
        getCache() {
            const route = this.$route,
                cookiesKey = `zzbCosWPA${route.name}`
            if (!route.name) {
                throw new Error("请在路由中配置name属性");
            }
            // 存储当前cookiesKey
            this.cookiesKey = cookiesKey;
            // 获取路由参数
            let values = route.params
            if (Object.keys(values).length) {
                // localStorage存储数据,防止页面刷新从store中取不到数据
                localStorage.setItem(cookiesKey, JSON.stringify(values))

            } else {
                // localStorage读取数据
                values = JSON.parse(localStorage.getItem(cookiesKey))
            }
            return values
        },
        // 向缓存的数组数据中写入新数据
        setCache(data) {
            localStorage.setItem(this.cookiesKey, JSON.stringify(data))
        }
    }
    // // 销毁缓存数据
    // beforeDestroy() {
    //     console.log('beforeDestroy')
    //     // localStorage.removeItem(this.cookiesKey)
    // }
}